export default "__VITE_ASSET__NYdKitGL__"